import React from 'react';

import { Box, Button, Flex, InlineNotification, Text } from '@lucidhq/lucidium';

import { t } from '~/utils/i18n';

type MediaTrackingNotRequiredProps = {
  disabled: boolean;
  onClick: () => void;
};

export const MediaTrackingNotRequired = ({
  disabled,
  onClick
}: MediaTrackingNotRequiredProps) => {
  return (
    <Flex lss={{ flexDirection: 'column' }}>
      <InlineNotification
        palette="secondary"
        title={t('campaignManager.review.mediaTracking.notRequired.title')}
      >
        <Box>
          <Text lss={{ mb: 'lg', display: 'block' }}>
            {t('campaignManager.review.mediaTracking.notRequired.description')}{' '}
          </Text>

          <Flex lss={{ justifyContent: 'center' }}>
            <Button emphasis="medium" disabled={disabled} onClick={onClick}>
              {t('campaignManager.review.mediaTracking.notRequired.confirm')}
            </Button>
          </Flex>
        </Box>
      </InlineNotification>
    </Flex>
  );
};
